import { Form } from '~/shared/api'
import { emptyRule, maxLengthRule, requiredRule } from '~/shared/utils/validation'
import { DictionaryItem } from '~/interfaces/Dictionary'

export default class AccountVacancyRequirementsForm extends Form {
  responsibilities: string = ''
  requirements: string = ''
  conditions: string = ''
  education: DictionaryItem | null = null
  experience: DictionaryItem | null = null

  toInputData() {
    return {
      responsibilities: this.responsibilities,
      requirements: this.requirements,
      conditions: this.conditions,
      education: this.education?.id,
      experience: this.experience?.id
    }
  }

  static rules() {
    return {
      responsibilities: { ...maxLengthRule(3000), ...emptyRule },
      requirements: { ...maxLengthRule(3000), ...emptyRule },
      conditions: { ...maxLengthRule(3000), ...emptyRule },
      education: requiredRule,
      experience: requiredRule
    }
  }
}
